var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.5 6.025a2.625 2.625 0 0 1-4.508 1.83l-6.814 3.933a2.63 2.63 0 0 1-.04 1.376l6.75 3.897a2.625 2.625 0 1 1-.616 1.375l-6.964-4.02a2.625 2.625 0 1 1 .119-3.924l6.87-3.968a2.625 2.625 0 1 1 5.203-.5",
    clipRule: "evenodd"
  })));
};
export default SvgShare;